import { SxProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppInfo } from 'hooks/useAppInfo';
import { getPushTokenFromLocalStorage } from 'state/localStorage';

type DeviceInfoProps = {
  sx?: SxProps;
};

export const DeviceInfo = (props: DeviceInfoProps): JSX.Element => {
  const { sx } = props;
  const { t } = useTranslation();
  const { appVersion } = useAppInfo();

  const pushToken = getPushTokenFromLocalStorage();
  // at 200k push token's the last 7 chars are unique, lets do 8 to avoid collisions
  const shortPushToken = pushToken?.slice(-8);

  return (
    <Typography variant="subtitle1" sx={sx}>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span>v{appVersion}</span>
      {shortPushToken && (
        <span>
          &nbsp;
          {t('drawerNav.device')} {shortPushToken}
        </span>
      )}
    </Typography>
  );
};
